import React from 'react';
import axios from 'axios';

import Auxi from '../../hoc/Auxi';
import AppLayout from '../Layout/AppLayout';
import Toast from '../../components/Widgets/CustomToast';


import '../../assets/css/style.css';

class VoiceMailSettings extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            recordType: 'vmail/new',
            voiceMails: [],
            username: "Daniyal",
            loading: false,
            audioSource: '',
            showModal: false,
            data: {},

        };
        this.playPauseRef = [];
    }

    inputChangeHandler = (evt) => {

        const target = evt.target;
        const name = target.name;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        if (value === true) {
            value = "yes";
        }

        if (value === false) {
            value = "no";
        }
        

        let data = this.state.data;
        data[name] = value;
        this.setState({ data });
    }
    
    getDeviceInfo = (userName, uType, password, cloudId) => {
    
        const payLoad = new FormData();
        payLoad.append('device', "sip:" + userName.split("@")[0] + "@" + userName.split("@")[1]);
        payLoad.append('domain', userName.split("@")[1]);
        payLoad.append('cloudId', cloudId);
        
        axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=device&action=read&utype=${uType}&cloud_username=${userName}&cloud_password=${password}`, payLoad)
        .then(response=>{
            this.setState({username: (response.data[0].aor_user) +'@'+((response.data[0].sub_login).split("@")[1])});

        })
        .catch(err=>{
            Toast.error(err.message);
        });
    }

    componentDidMount(){

        // infoOnExistingUser will provide the settings data

        let mUrl = decodeURIComponent(window.location.href)
        let url = new URL(
            decodeURIComponent(window.location.href)
        )
        let username = url.searchParams.get('username');
        let password = url.searchParams.get('password');
        let cloudId = url.searchParams.get('cloud_id');
        mUrl = mUrl.substring(
            mUrl.lastIndexOf("?username="),
            mUrl.length
        );
        this.setState({url: mUrl});

			// let username = url.substring(
      //   url.lastIndexOf("?username=") + 10,
			// 	url.lastIndexOf("&password=")
			// );
			// let password = url.substring(
			// 	url.lastIndexOf("&password=") + 10,
      //   url.lastIndexOf("&cloud_id=")
			// );
			// let cloudId = url.substring(
			// 	url.lastIndexOf("&cloud_id=") + 10,
      //   url.length
			// );
        password = encodeURIComponent(password);
        this.setState({username: username});
        this.setState({password: password});
        this.setState({cloudId: cloudId});

        let uType = 's';
        if(username.includes("QR")){
            // Here everything is based upon superuser
            this.getDeviceInfo(username, uType, password, cloudId);
            this.setState({uType: uType});
            return
        }

        // Here we will get everything based upon simple user
        uType = 'u';
        const payLoad = {
            user: username,
            password: password,
            cloud_id: cloudId
        }

        axios.post(`${process.env.REACT_APP_API_URL}/signin`, payLoad)
        .then(response=>{
            username =  response.data.user + "@" + response.data.domain;
            this.setState({username: username});
            this.setState({uid: response.data.uid});
            this.setState({uType: uType});
        })
        .catch(err=>{
            Toast.error(err.message);
        });
        

    }


    render() {

        return(
            <Auxi>
                <AppLayout cloud_id="SAEVOLGO"
                    display_name = {this.state.username}
                    ownContact = {this.state.ownContact}
                    url={this.state.url}/>

                <div className = "MainIndexApp vmSettingsPage">
                    <div className="row voice-message-layout">
                        {/* <object type="text/html" data="https://crexendo-core-021-las.cls.iaas.run/video/" style={{width: "100%", height:"550px"}}>
                        </object> */}

                        <iframe src="https://iotum.callbridge.rocks/auth?host_id=64440&login_token_public_key=39abd592be30daf3245eaf5f6d3f75b17e90ba5db1e86ac38f606bceec6f2ce1&redirect_url=/conf/conferences/create" style={{width: "100%", height:"550px"}}></iframe>
                    </div>
                </div>
            </Auxi>

        );

    }

}

export default VoiceMailSettings;
